<script setup>
import { useAppStore } from '@/store';
const appStore = useAppStore();

// Default to MovePro blue
const inputTheme = ref('#1F3DF0');

watch(
    () => appStore.tenant?.accent,
    (newVal) => {
        if (newVal) {
            inputTheme.value = newVal;
        }
    },
);

const theme = computed(() => {
    const shades = generateShades(inputTheme.value);

    console.log({ shades });

    return {
        '--brand-primary': adjustColor(inputTheme.value, 0),
        '--brand-primary-dark': shades.darker[0],
    };
});

// get body tag and set the theme whenver inputTheme changes
watch(
    inputTheme,
    () => {
        const body = document.querySelector('body');
        if (body) {
            Object.entries(theme.value).forEach(([key, value]) => {
                body.style.setProperty(key, value);
            });
        }
    },
    {
        immediate: true,
    },
);

function adjustColor(hex, factor) {
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);

    r = Math.min(255, Math.max(0, r + factor));
    g = Math.min(255, Math.max(0, g + factor));
    b = Math.min(255, Math.max(0, b + factor));

    return `${r} ${g} ${b}`;
}

function generateShades(hex) {
    const shades = {
        lighter: [],
        darker: [],
    };

    for (let i = 1; i <= 3; i++) {
        const factor = i * 15; // Adjust this value to change the intensity of the shades
        shades.lighter.push(adjustColor(hex, factor));
        shades.darker.push(adjustColor(hex, -factor));
    }

    return shades;
}
</script>
